<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />

    <section
      class="order-page-main-sec order-invoice-page-main-sec agency-design-grid-right"
    >
      <div
         class="desktop-respovsive-main-sec" 
         >
        <div class="editor-dashboard-sec-2" id="printSection">
          <div v-if="isAgencyInvoice" class="agency-generated-invoice">
            <iframe
              v-if="agencyPdfUrl"
              :src="agencyPdfUrl"
              class="agency-invoice-frame"
              title="Invoice"
            ></iframe>
          </div>
          <template v-else>
          <div class="order-list-tabs">
            <div class="invoice-logo">
              <a href="#"><img src="@/assets/common/images/lbhq-logo.svg" /></a>
            </div>
            <div class="invoice-detal-list">
              <ul>
                <li><b>Bill To</b></li>
                <li>
                  <b>{{ name }}</b>
                </li>
                <li v-if="address">
                  {{ address }}<br />{{ state }} {{ postal_code }}, <br />
                  {{ country }}
                </li>
                <li>{{ phone }}</li>
                <li v-if="vat != null">VAT: {{ vat }}</li>
              </ul>
              <ul>
                <li><b>Invoice</b></li>
                <li v-if="orderType == 'package'">Package Name: {{ packageName }}</li>
                <li>Order Date: {{ date }}</li>
                <li>Order Title: {{ order_title }}</li>
                <li>Payment Method: {{ payment_method }}</li>
                <li v-if="invoiceNumber">Invoice # {{ invoiceNumber }}</li>
                <li v-if="orderStatus === 'Payment Failed'">Status: Payment Failed</li>
              </ul>
            </div>
          </div>   
          <div class="table-responsive custom-order-class" v-if="isInvoiceOrder">
            <form>
              <table class="addon-table billing-invoice-table">
                <tr>
                  <th class="col-custom-id">ID</th>
                  <th class="col-custom-title">Order Title</th>
                  <th class="col-custom-links">Total Links</th>
                  <th class="col-custom-amount">Amount</th>
                </tr>
                <tr
                  v-for="(billingInvoice, index) in billing_invoice"
                  :key="'custom-item-' + index"
                >
                  <td class="col-custom-id">{{ billingInvoice.id }}</td>
                  <td class="col-custom-title">{{ billingInvoice.order_title }}</td>
                  <td class="col-custom-links">{{ billingInvoice.total_links }}</td>
                  <td class="col-custom-amount">
                    {{ numberFormat(billingInvoice.price, "currency") }}
                  </td>
                </tr>
              </table>
            </form>
          </div>
          <div class="table-responsive" v-else :class="{ 'missed-opportunity-class': orderType == 'missed_opportunity', 'media-placement-class': orderType == 'media_placement', 'brand-mention-class': orderType == 'brand_mention' }">
            <form>
              <table class="addon-table billing-invoice-table">
                <tr v-if="orderType == 'brand_mention'">
                  <th class="col-da-dr">DA/DR</th>
                  <th class="col-link-type">Link Type</th>
                  <th class="col-brand-website">Brand Website</th>
                  <th class="col-placement-type">Placement Type</th>
                  <th class="col-addons">Add-Ons</th>
                  <th class="col-price">Price</th>
                </tr>
                <tr v-if="orderType != 'brand_mention'">
                  <th v-if="orderType == 'missed_opportunity' || orderType == 'media_placement'" class="col-placement-url">Placement URL</th>
                  <th v-if="orderType == 'media_placement'" class="col-type-website">Type of Website</th>
                  <th
                    v-else
                    :class="{ 'col-da-dr': orderType === 'normal' || orderType === 'package' }"
                  >DA/DR</th>
                  <!-- <th v-if="orderType == 'missed_opportunity'">DR</th> -->
                  <th v-if="orderType != 'media_placement'">Category</th>
                  <th class="col-destination">Destination URL</th>
                  <th class="col-traffic" v-if="orderType == 'missed_opportunity'">Traffic</th>
                  <th v-if="orderType == 'package'">Anchor Text</th>
                  <th v-if="orderType != 'media_placement' && orderType != 'package'">Add-Ons</th>
                  <th class="col-rel-attribute" v-if="orderType == 'media_placement'">Rel Attribute</th>
                  <th class="col-sponsored-tag" v-if="orderType == 'media_placement'">Sponsored Tag</th>
                  <th class="col-price">Price</th>
                </tr>
                <tr
                  v-for="billingInvoice in brandMentionInvoices"
                  :key="`brand-${billingInvoice.id}`"
                >
                  <td class="col-da-dr" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.product }}</td>
                  <td class="col-link-type" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.link_type }}</td>
                  <td class="col-brand-website" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">
                    <a @click="redirectURL(billingInvoice.brand_website)" v-b-tooltip.hover.top="billingInvoice.brand_website" class="destination-link"
                      >{{ billingInvoice.brand_website }}
                      <i class="fas fa-external-link-alt"></i
                    ></a>
                  </td>
                  <td class="col-placement-type" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.placement_type }}</td>
                  <td class="col-addons" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">
                    <div class="invoice-addons-wrap" v-if="getInvoiceAddonItems(billingInvoice).length">
                      <span
                        v-for="(addon, idx) in getInvoiceAddonItems(billingInvoice)"
                        :key="`${billingInvoice.id}-brand-addon-${idx}`"
                        class="invoice-addon-pill"
                      >
                        {{ addon }}
                      </span>
                    </div>
                    <span v-else>—</span>
                  </td>
                  <td class="col-price" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">
                    {{ numberFormat(billingInvoice.price,'currency') }}
                  </td>
                </tr>
                <tr
                  v-for="billingInvoice in standardInvoices"
                  :key="billingInvoice.id"
                >
                  <td
                    class="col-placement-url"
                    :class="{ 'refund-text': billingInvoice.status == 'Refund' }"
                    v-if="orderType == 'missed_opportunity' || orderType == 'media_placement'"
                  >
                    <a @click="redirectURL(billingInvoice.placement_url)" v-b-tooltip.hover.top="billingInvoice.placement_url" class="destination-link"
                      >{{ billingInvoice.placement_url }}
                      <i class="fas fa-external-link-alt"></i
                    ></a>
                  </td>
                  <td v-if="orderType == 'media_placement'" class="col-type-website" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.type_of_website }}</td>
                  <td
                    v-if="orderType != 'media_placement'"
                    :class="[
                      { 'col-da-dr': orderType === 'normal' || orderType === 'package' },
                      { 'refund-text': billingInvoice.status == 'Refund' },
                    ]"
                  >{{ billingInvoice.product }}</td>
                  <td v-if="orderType != 'media_placement'" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.category }}</td>
                  <td class="col-destination" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">
                    <a @click="redirectURL(billingInvoice.link)" v-b-tooltip.hover.top="billingInvoice.link" class="destination-link"
                      >{{ billingInvoice.link }}
                      <i class="fas fa-external-link-alt"></i
                    ></a>
                  </td>
                  <td
                    class="col-traffic"
                    v-if="orderType == 'missed_opportunity'"
                    :class="{ 'refund-text': billingInvoice.status == 'Refund' }"
                  >
                    {{ formatTrafficDisplay(billingInvoice.traffic) }}
                  </td>
                  <template v-if="orderType == 'package'">
                    <td :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.anchor_text }}</td>
                  </template>
                  <template v-if="orderType != 'media_placement' && orderType != 'package'">
                    <td :class="{ 'refund-text': billingInvoice.status == 'Refund' }">
                      <div class="invoice-addons-wrap" v-if="getInvoiceAddonItems(billingInvoice).length">
                        <span
                          v-for="(addon, idx) in getInvoiceAddonItems(billingInvoice)"
                          :key="`${billingInvoice.id}-addon-${idx}`"
                          class="invoice-addon-pill"
                        >
                          {{ addon }}
                        </span>
                      </div>
                      <span v-else>—</span>
                    </td>
                  </template>
                  <template v-if="orderType == 'media_placement'">
                    <td class="col-rel-attribute" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.rel_attribute }}</td>
                    <td class="col-sponsored-tag" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">{{ billingInvoice.sponsored_tag }}</td>
                  </template>
                  <!-- <td v-if="orderType == 'missed_opportunity'">
                    {{ billingInvoice.content_approval != 'None' ? numberFormat((billingInvoice.price + 25),'currency') : numberFormat(billingInvoice.price,'currency') }}
                  </td>
                  <td v-else>
                    {{ numberFormat(billingInvoice.price,'currency') }}
                  </td> -->
                  <td class="col-price" :class="{ 'refund-text': billingInvoice.status == 'Refund' }">
                    {{
                      orderType == 'missed_opportunity'
                        ? numberFormat(
                            Number(billingInvoice.total_price ?? billingInvoice.price),
                            'currency'
                          )
                        : numberFormat(billingInvoice.price,'currency')
                    }}
                  </td>
                </tr>
              </table>
            </form>
          </div>

          <!-- Custom Order Proceed Box -->
          <div class="proceed-box" v-if="isInvoiceOrder">
            <div class="total-price-table-box proceed-pay-box custom-invoice-summary">
              <table style="width: 100%">
                <tr class="bg-text">
                  <td colspan="2"></td>
                  <td>Qty</td>
                  <td>Price</td>
                </tr>
                <tr
                  v-for="(summaryRow, index) in customSummaryRows"
                  :key="'custom-summary-' + index"
                >
                  <td colspan="2">{{ summaryRow.label }}</td>
                  <td>{{ summaryRow.qty }}</td>
                  <td>{{ summaryRow.amount }}</td>
                </tr>
                <tr>
                  <td colspan="2">Subtotal</td>
                  <td colspan="2">
                    USD {{ numberFormat(sub_total, "currency") }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">Total</td>
                  <td colspan="2">
                    <b>USD {{ numberFormat(order_total, "currency") }}</b>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <!-- Missed Opportunity Proceed Box -->
          <div class="proceed-box" v-else-if="orderType == 'missed_opportunity'">
            <div class="total-price-table-box proceed-pay-box">
              <table style="width: 100%">
                <tr class="bg-text">
                  <td colspan="2"></td>
                  <td>Qty</td>
                  <td>Price</td>
                </tr>
                <tr v-for="(summaryData) in summaryPaymentData"
                  :key="summaryData.placement">
                  <td colspan="2"><span class="link-text">{{ summaryData.placement }}</span></td>
                  <td>{{ summaryData.total_links }}</td>
                  <td>
                    {{ numberFormat(summaryData.total_cost, "currency") }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">{{ invoiceLinksLabel }}</td>
                  <td>{{ billing_invoice.length }}</td>
                  <td>
                    {{ numberFormat(links_total, "currency") }}
                  </td>
                </tr>
                <!-- <tr>
                  <td colspan="2">Addons:</td>
                  <td>{{ total_addons }}</td>
                  <td>
                    {{ numberFormat(total_addon_cost,'currency') }}
                  </td>
                </tr> -->
                <tr>
                  <td colspan="2">Subtotal:</td>
                  <td colspan="2">
                    USD
                    {{ numberFormat(sub_total,'currency') }}
                  </td>
                </tr>
                <tr v-if="Number(discount) > 0">
                  <td colspan="2">Discount:</td>
                  <td colspan="2">
                    (USD
                    {{ numberFormat(sub_total - order_total,'currency') }})
                  </td>
                </tr>
                <tr>
                  <td colspan="2">Total:</td>
                  <td colspan="2">
                    <b
                      >USD
                      {{ numberFormat(order_total,'currency') }}</b
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <!-- Media Placement Order Proceed Box -->
          <div class="proceed-box" v-else-if="orderType == 'media_placement'">
            <div class="total-price-table-box proceed-pay-box">
              <table style="width: 100%">
                <tr class="bg-text">
                  <td colspan="2"></td>
                  <td>Qty</td>
                </tr>
                <tr>
                  <td colspan="2">{{ invoiceLinksLabel }}</td>
                  <td>{{ billing_invoice.length }}</td>
                </tr>
                <tr>
                  <td colspan="2">Subtotal</td>
                  <td colspan="2">
                    USD
                    {{ numberFormat(sub_total,'currency') }}
                  </td>
                </tr>
                <tr v-if="isAchPayment && Number(discount) > 0">
                  <td colspan="2">Discount</td>
                  <td colspan="2">
                    (USD
                    {{ numberFormat(sub_total - order_total,'currency') }})
                  </td>
                </tr>
                <tr>
                  <td colspan="2">Total</td>
                  <td colspan="2">
                    <b
                      >USD
                      {{ numberFormat(order_total,'currency') }}</b
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <!-- Normal Order Proceed Box -->
          <div v-else class="proceed-box">
            <div class="total-price-table-box proceed-pay-box">
              <table style="width: 100%">
                <tr class="bg-text">
                  <td colspan="2"></td>
                  <td>Qty</td>
                  <td>Price</td>
                </tr>
                <tr>
                  <td colspan="2">{{ invoiceLinksLabel }}</td>
                  <td>{{ billing_invoice.length }}</td>
                  <td>
                    {{ orderType != 'package' ? numberFormat(links_total,'currency') : numberFormat(order_total,'currency') }}
                  </td>
                </tr>
                <tr v-if="orderType != 'package'">
                  <td colspan="2">Addons</td>
                  <td>{{ total_addons }}</td>
                  <td>
                    {{ numberFormat(total_addon_cost,'currency') }}
                  </td>
                </tr>
                <tr v-if="orderType != 'package'">
                  <td colspan="2">Subtotal</td>
                  <td colspan="2">
                    USD
                    {{ numberFormat(sub_total,'currency') }}
                  </td>
                </tr>
                <tr v-if="orderType != 'package' && Number(discount) > 0">
                  <td colspan="2">Discount</td>
                  <td colspan="2">
                    (USD
                    {{ numberFormat(sub_total - order_total,'currency') }})
                  </td>
                </tr>
                <tr>
                  <td colspan="2">Total</td>
                  <td colspan="2">
                    <b
                      >USD
                      {{ numberFormat(order_total,'currency') }}</b
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>
          </template>

          <div class="btn-box-list">
            <a href="#" @click="downloadBillingInvoice('invoice')"
              ><i class="fas fa-download"></i> Download</a
            >
            <a href="#" @click="sendInvoice()"
              ><i class="fas fa-envelope"></i> Email</a
            >
            <a href="#" @click="printSection('invoice')" id="print-button"
              ><i class="fas fa-print"></i> Print</a
            >
          </div>
        </div>

        <div class="bottom-bar">
          <ul>
            <li>219 N Brown Ave, Orlando, FL 32801</li>
            <li>© {{new Date().getFullYear()}} - linkbuildinghq.com</li>
            <li>
              <a href="mailto:letstalk@linkbuildinghq.com"
                >letstalk@linkbuildinghq.com</a
              >
            </li>
          </ul>
        </div>
      </div>
    </section>
    <iframe ref="printFrame" style="display: none"></iframe>
  </div>
</template>

<style>
.agency-generated-invoice {
  width: 100%;
  min-height: 80vh;
}
.agency-invoice-frame {
  width: 100%;
  min-height: 80vh;
  border: 0;
  background: #fff;
}
.order-invoice-page-main-sec .table-responsive.custom-order-class .billing-invoice-table {
  min-width: 0 !important;
  width: 100%;
  table-layout: fixed;
}
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr td:first-child,
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr th:first-child {
  width: 90px !important;
  text-align: left !important;
}
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr td:nth-child(2),
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr th:nth-child(2) {
  width: 42% !important;
  max-width: 280px !important;
  min-width: 0 !important;
  text-align: left !important;
}
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr td:nth-child(3),
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr th:nth-child(3) {
  width: 22% !important;
  text-align: center !important;
}
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr td:last-child,
.order-invoice-page-main-sec .table-responsive.custom-order-class table tr th:last-child {
  width: 22% !important;
  text-align: center !important;
  padding-right: 16px !important;
  background-color: transparent;
}
.custom-invoice-summary table tr td:nth-child(3),
.custom-invoice-summary table tr td:nth-child(4),
.custom-invoice-summary table tr.bg-text td:nth-child(3),
.custom-invoice-summary table tr.bg-text td:nth-child(4) {
  text-align: center;
}
</style>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import { numberFormat } from '@/prod.js';
import { getInvoiceLinksLabel } from "@/utils/invoiceLabels";
import { useToast } from "vue-toastification";

const toast = useToast();
export default {
  components: {
    HeaderView,
    LoaderComponent,
    // pdfInvoice,
  },
  mounted() {
    var url = window.location.pathname;
    var id = url.substring(url.lastIndexOf("/") + 1);
    this.invoice_id = id;
    this.getBillingInvoice();
  },
  beforeUnmount() {
    if (this.agencyPdfUrl) {
      window.URL.revokeObjectURL(this.agencyPdfUrl);
    }
  },
  data() {
    return {
      numberFormat,
      loading: false,
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false,
      },
      plugins: [{ src: "@/plugins/vue3-html2pdf", mode: "client" }],
      pageBreak: false,
      invoice_id: "",
      download: "",
      billing_invoice: [],
      address: "",
      state: "",
      postal_code: "",
      city_name: "",
      country: "",
      date: "",
      invoiceNumber: "",
      name: "",
      vat: "",
      payment_method: "",
      orderStatus: "",
      phone: "",
      order_title: "",
      order_total: "",
      discount: "",
      sub_total: "",
      links_total: "",
      total_addons: "",
      total_addon_cost: "",
      da_20_count: 0,
      da_20_total: 0,
      da_30_count: 0,
      da_30_total: 0,
      da_40_count: 0,
      da_40_total: 0,
      da_50_count: 0,
      da_50_total: 0,
      da_60_count: 0,
      da_60_total: 0,
      dr_20_count: 0,
      dr_20_total: 0,
      dr_30_count: 0,
      dr_30_total: 0,
      dr_40_count: 0,
      dr_40_total: 0,
      dr_50_count: 0,
      dr_50_total: 0,
      dr_60_count: 0,
      dr_60_total: 0,
      filename: "billing",
      DADRText: 'DA',
      orderType: 'normal',
      packageName: '',
      isAgencyInvoice: false,
      agencyPdfUrl: '',
      customSummaryRows: [],
      isInvoiceOrder: false,
    };
  },
  methods: {
    resolveInvoiceLinksLabel(orderType, count) {
      return getInvoiceLinksLabel(orderType, count);
    },
    formatTrafficDisplay(value) {
      if (value === null || value === undefined || value === "") return "—";
      const raw = String(value).trim();
      if (!raw) return "—";

      // Accept mixed formats like "245", "12,45", "256,422".
      const normalized = raw.replace(/,/g, "").replace(/[^\d.]/g, "");
      const parsed = Number(normalized);
      if (!Number.isFinite(parsed) || parsed <= 0) return "—";
      return Math.floor(parsed).toLocaleString();
    },
    isAddonValuePresent(value) {
      const raw = String(value ?? "").trim();
      if (!raw) return false;
      const normalized = raw.toLowerCase();
      return !["none", "n/a", "na", "null", "undefined", "0", "false", "-"].includes(normalized);
    },
    norm(v) {
      return String(v ?? "").trim().toLowerCase();
    },
    parseAddonCost(value) {
      if (typeof value === "number") return Number.isFinite(value) ? value : 0;
      const raw = String(value ?? "").trim();
      if (!raw) return 0;
      const cleaned = raw.replace(/,/g, "").replace(/[^\d.-]/g, "");
      const n = Number(cleaned);
      return Number.isFinite(n) ? n : 0;
    },
    splitValueAndPrice(value) {
      const raw = String(value ?? "").trim();
      if (!raw) return { cleanValue: "", inlineCost: 0 };
      const m = raw.match(/^(.*)\(\s*\$?\s*([\d,]+(?:\.\d+)?)\s*\)\s*$/);
      if (!m) return { cleanValue: raw, inlineCost: 0 };
      return {
        cleanValue: String(m[1] || "").trim(),
        inlineCost: this.parseAddonCost(m[2]),
      };
    },
    formatTrafficStabilityValue(value) {
      const raw = String(value || "").trim();
      if (!raw) return raw;
      if (/\b12\b/i.test(raw)) return raw.replace(/12\s*month\s*stable\s*traffic/gi, "12mo");
      if (/\b6\b/i.test(raw)) return raw.replace(/6\s*month\s*stable\s*traffic/gi, "6mo");
      return raw;
    },
    formatLessThanValue(value) {
      const raw = String(value || "").trim();
      if (!raw) return "—";
      return raw.replace(/less\s*than\s*/gi, "< ");
    },
    mapAddonTitle(name) {
      const n = this.norm(name);
      if (n.includes("minimum traffic")) return "Minimum Traffic";
      if (n === "country") return "Country";
      if (n.includes("traffic stability")) return "Traffic Stability";
      if (n.includes("spam score")) return "Spam Score";
      if (n.includes("rd:ld ratio")) return "RD:LD Ratio";
      if (n.includes("cf:tf ratio")) return "CF:TF Ratio";
      if (n.includes("content approval")) return "Content Approval";
      if (n.includes("niche purity")) return "Niche Purity";
      return String(name || "Add-On").trim();
    },
    normalizeAddonValue(title, value) {
      const n = this.norm(title);
      if (n.includes("traffic stability")) return this.formatTrafficStabilityValue(value);
      if (n.includes("spam score")) return this.formatLessThanValue(value);
      return String(value || "").trim();
    },
    formatAddonPrice(cost) {
      const c = this.parseAddonCost(cost);
      return c > 0 ? `(${this.numberFormat(c, "currency")})` : "";
    },
    toAddonText(name, value, cost = 0) {
      if (!this.isAddonValuePresent(name) || !this.isAddonValuePresent(value)) return null;
      const title = this.mapAddonTitle(name);
      const { cleanValue, inlineCost } = this.splitValueAndPrice(value);
      const normalizedValue = this.normalizeAddonValue(title, cleanValue || value);
      const priceText = this.formatAddonPrice(this.parseAddonCost(cost) || inlineCost);
      return `${title}: ${normalizedValue}${priceText ? ` ${priceText}` : ""}`;
    },
    parseAddonRows(row) {
      let addonRows = row?.addons;
      if (typeof addonRows === "string") {
        try {
          addonRows = JSON.parse(addonRows);
        } catch {
          addonRows = [];
        }
      }
      return Array.isArray(addonRows) ? addonRows : [];
    },
    getInvoiceAddonItems(row) {
      const items = [];
      const push = (name, value, cost = 0) => {
        const text = this.toAddonText(name, value, cost);
        if (text) items.push(text);
      };

      if (this.orderType === "normal") {
        push("Minimum Traffic", row?.minimum_traffic, row?.minimum_traffic_cost);
        push("Country", row?.uk_tld, row?.uk_tld_cost);
      } else if (this.orderType === "missed_opportunity") {
        push("Content Approval", "Yes");
      }
      if (this.orderType !== "missed_opportunity") {
        push("Content Approval", row?.content_approval, row?.content_approval_cost);
      }

      this.parseAddonRows(row).forEach((a) => {
        push(
          a?.addon_name || a?.name,
          a?.value || a?.option || a?.selected || a?.name,
          a?.cost ?? a?.price ?? a?.amount
        );
      });

      return [...new Set(items)];
    },
    async getBillingInvoice(downloadVal) {
      this.loading = true;
      this.download = downloadVal == "invoice" ? downloadVal : "";
      try {
        let res = await this.$store.dispatch("Billing/getInvoiceDataAction", {
          id: this.invoice_id,
          download: this.download,
        });
        if(res.invoice_hold){
          this.$router.push("/dashboard");
        }
        if (res.is_agency_invoice) {
          this.isAgencyInvoice = true;
          this.filename = res.filename || "invoice.pdf";
          this.invoiceNumber = res.invoice_number || res.invoice_no || "";
          await this.loadAgencyInvoicePdf();
          this.loading = false;
          return;
        }
        this.isAgencyInvoice = false;
        if(res.invoice_detail && res.invoice_detail.length > 0){
          this.orderType = res.invoice_detail[0].order_type;
        }
        this.isInvoiceOrder = !!res.use_invoice_items_layout || this.orderType === "custom_order";
        this.billing_invoice = res.invoice_detail;
        this.address = res.agency_address;
        this.country = res.country;
        this.state = res.state;
        this.postal_code = res.postal_code;
        this.city_name = res.city_name;
        this.date = res.date;
        this.invoiceNumber = res.invoice_number || res.invoice_no || "";
        this.name = res.name;
        this.vat = res.vat;
        this.payment_method = res.payment_method;
        this.orderStatus = res.order_status || "";
        this.phone = res.phone;
        this.order_title = res.order_title;
        if(this.orderType == 'package'){
          this.packageName = res.package_name;
        }
        this.discount = res.discount;
        this.sub_total = res.sub_total;
        this.order_total = res.order_total;
        this.customSummaryRows = res.summary_rows || [];
        this.links_total = res.links_total;
        this.total_addons = res.total_addons;
        this.total_addon_cost = res.total_addon_cost;
        this.da_20_count = res.da_20_count;
        this.da_20_total = res.da_20_total;
        this.da_30_count = res.da_30_count;
        this.da_30_total = res.da_30_total;
        this.da_40_count = res.da_40_count;
        this.da_40_total = res.da_40_total;
        this.da_50_count = res.da_50_count;
        this.da_50_total = res.da_50_total;
        this.da_60_count = res.da_60_count;
        this.da_60_total = res.da_60_total;
        this.dr_20_count = res.dr_20_count;
        this.dr_20_total = res.dr_20_total;
        this.dr_30_count = res.dr_30_count;
        this.dr_30_total = res.dr_30_total;
        this.dr_40_count = res.dr_40_count;
        this.dr_40_total = res.dr_40_total;
        this.dr_50_count = res.dr_50_count;
        this.dr_50_total = res.dr_50_total;
        this.dr_60_count = res.dr_60_count;
        this.dr_60_total = res.dr_60_total;
        this.filename = res.filename;
        const firstRow = res.invoice_detail && res.invoice_detail[0];
        if (firstRow && firstRow.product && String(firstRow.product).startsWith("DR")) {
          this.DADRText = 'DR';
        }
        if(this.orderType == "missed_opportunity"){
          this.paymentSummaryMO();
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$router.push("/dashboard");
      }
    },
    async loadAgencyInvoicePdf() {
      if (this.agencyPdfUrl) {
        window.URL.revokeObjectURL(this.agencyPdfUrl);
        this.agencyPdfUrl = "";
      }
      const response = await this.$store.dispatch("Billing/getInvoiceDataAction", {
        id: this.invoice_id,
        download: "invoice",
      });
      let blob = new Blob([response], {
        type: "application/pdf",
      });
      this.agencyPdfUrl = window.URL.createObjectURL(blob);
    },
    paymentSummaryMO(){
      this.summaryPaymentData = [];
      const result = {};

      this.billing_invoice.forEach(placement => {
          const url = placement.placement_url;
          const cost = placement.total_price;
       
          if (!result[url]) {
              result[url] = { placement: url, total_links: 0, total_cost: 0 };
          }

          result[url].total_links += 1;
          result[url].total_cost += cost;
          // if(placement.content_approval != "None"){
          //   result[url].total_cost += 25;
          // }
      });
      this.summaryPaymentData = result;
    },

    async sendInvoice() {
      this.loading = true;
      try {
        let res = await this.$store.dispatch(
          "Billing/sendInvoiceEmailDataAction",
          this.invoice_id
        );
        if (res.success) {
          this.loading = false;
          this.messages = res.message;
          toast.success(res.message, { timeout: 3000 });
        }
      } catch (error) {
        this.loading = false;
        this.errors = error.response.data.errors;
      }
    },

    async printSection(printVal) {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(
          "Billing/getInvoiceDataAction",
          {
            id: this.invoice_id,
            download: printVal,
          }
        );
        let contentBlob = new Blob([response], {
          type: "application/pdf",
        });

        // Create a URL for the content
        // const contentUrl = URL.createObjectURL(contentBlob);
        let contentUrl = document.createElement("a");
        contentUrl.href = window.URL.createObjectURL(contentBlob);

        // Display the content in the iframe
        const printFrame = this.$refs.printFrame;
        printFrame.src = contentUrl;

        // Wait for a moment to ensure the content is loaded
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Print the content
        printFrame.contentWindow.print();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        toast.error(error, { timeout: 3000 });
      }
    },

    async downloadBillingInvoice(downloadVal) {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(
          "Billing/getInvoiceDataAction",
          {
            id: this.invoice_id,
            download: downloadVal,
          }
        );
        let blob = new Blob([response], {
          type: "application/pdf",
        });
        const filename = this.filename;
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        toast.error(error, { timeout: 3000 });
      }
    },

    async generateReport() {
      this.$refs.pdfComponentRef.generatePDFReport();
    },
    redirectURL(url) {
      const pattern = /^(http:\/\/|https:\/\/)/i;
      const hasHttpOrHttps = pattern.test(url);

      let finalUrl = url;
      if (!hasHttpOrHttps) {
        finalUrl = "https://" + url;
      }
      console.log(finalUrl);
      const newTab = window.open(finalUrl, "_blank");
      if (newTab) {
        newTab.focus();
      }
    },
  },
  watch: {},
  computed: {
    isAchPayment() {
      return String(this.payment_method || "").trim().toLowerCase() === "ach";
    },
    invoiceLinksLabel() {
      return this.resolveInvoiceLinksLabel(this.orderType, this.billing_invoice.length);
    },
    brandMentionInvoices() {
      return this.orderType == "brand_mention" ? this.billing_invoice : [];
    },
    standardInvoices() {
      return this.orderType == "brand_mention" ? [] : this.billing_invoice;
    },
  },
};
</script>
